module.exports = __webpack_public_path__ + "static/media/logo.6139be27.svg";